import { render, staticRenderFns } from "./customerRoleSelect.vue?vue&type=template&id=9b267c00&"
import script from "./customerRoleSelect.vue?vue&type=script&lang=js&"
export * from "./customerRoleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports